export const MAX_MOBILE_WIDTH = 767;
export const EX_SMALL_VIEWPORT_HEIGHT = 300;
export const SEARCH_EXPOSED_WIDTH = 980;
export const GITHUB_LOCATION = 'https://github.com/freeCodeCamp';
